// bnz-briefing.ts
import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const BNZEmployeeSafetyFileDataSchema = yup.object().shape({
  submittedAt: yup.string().nullable().optional(),
  submittedBy: yup.string().nullable().optional(),
  submissionSignature: yup.string().nullable().optional(),
  language: yup.string().nullable().optional(),
})

export type BNZEmployeeSafetyFileData = yup.InferType<typeof BNZEmployeeSafetyFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<BNZEmployeeSafetyFileData>

export const BNZEmployeeSafetyFileMappings: RequiredFileData = {
  submittedAt: 'bc5d5156-c9d5-4fdf-acf0-33407af4e2b9',
  submittedBy: 'b563d940-245f-41a2-88fa-cc3ebdee1d2f',
  submissionSignature: '34793a0e-6f9d-4896-a5fc-a4847e5b1fd7',
  language: 'f078abd8-0802-4a88-b827-dc93b1bba44b',
}
